import React, { useState, useEffect } from "react";
import { Grid, Select, FormControl, MenuItem, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { useSelector } from "react-redux";

// Images
import exhaustfan from "../../assets/Images/Exhaust Fan.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  formControl: {
    width: "max-content",
    minWidth: "100%",
    backgroundColor: "#eeeef5",
    fontFamily: "Arial",
    height: "6vh",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421",
    opacity: "1",
    borderRadius: "12px",
    height: "15vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 0",
  },
  cardHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    marginTop: "1vh",
    font: "normal normal medium 17px/60px Bw Seido Round",
    opacity: "1",
    fontWeight: "bold",
    fontSize: "1.7vh",
    textAlign: "center",
  },
  select: {
    fontWeight: "bold",
    height: "6vh",
    borderRadius: "0.8vw",
    fontFamily: "Arial",
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      fontSize: "2vh",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "12px",
    opacity: "1",
  },
}));

export default function Eqp_Details() {
  // Format values for Exhaust Fan parameters
  const formatValue = (attrKey, val) => {
  // ✅ handle no data from DB
  if (val === null || val === undefined || val === "") {
    return "-"; // default display
  }

  switch (attrKey) {
    case "EXHAUST_FAN_Run_SS":
      return val === "active" || val === 1 || val === "1" ? "ON" : "OFF";

   

    case "EXHAUST_FAN_AM_SS":
      return val === "active" || val === 1 || val === "1" ? "Auto" : "Manual";

    default:
      return val;
  }
};

  const classes = useStyles();

  const [equipmentData, setEquipmentData] = useState({});
  const [selectedDevice, setSelectedDevice] = useState("");
  const [fdata, setFdata] = useState("all"); // Changed default to "all"
  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const [fid, setFId] = useState("all"); // Changed default to "all"
  const [floor, setFloor] = useState([]);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  useEffect(() => {
    let zone_id = "",
      z_data = [];
    zone_data.sort(function (a, b) {
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    });
    zone_data.filter((_each) => _each.zone_type === "GL_LOCATION_TYPE_FLOOR");
    console.log("zone_data", zone_data, "fdata", fdata);

    // Only try to find specific floor if fdata is not "all"
    if (fdata !== null && fdata !== "all") {
      zone_data.filter((_each, i) => {
        if (
          _each.zone_type === "GL_LOCATION_TYPE_FLOOR" &&
          _each.name === fdata
        ) {
          zone_id = _each.uuid;
          setFId(_each.uuid); // Set the fid here
          return true;
        }
        return false;
      });
    }

    api.dashboard
      .getMetricData(buildingID)
      .then((res) => {
        const sorted = res.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );

        setFloor(sorted);
      })
      .catch((error) => {
        console.log(error);
      });
    api.floor.cpmGetDevData().then((res) => {
      const exhaustfanOnly = { SS_EXHAUST_FAN: res["SS_EXHAUST_FAN"] };
      setEquipmentData(exhaustfanOnly);
      setSelectedDevice("");
    });
  }, []);

  const typeNameMap = {
    SS_EXHAUST_FAN: "",
  };

  const typeImageMap = {
    SS_EXHAUST_FAN: exhaustfan,
  };

  // Define parameters in the exact order they should appear
  const parameterOrder = [
    "EXHAUST_FAN_Run_SS",
    "EXHAUST_FAN_AM_SS",
  ];

  // Define which parameters to show and their display names
  const allowedParameters = {
    EXHAUST_FAN_Run_SS: "Run Status",
    EXHAUST_FAN_AM_SS: <>
        Auto/Manual
        <br />
        Status
      </>,
   // EXHAUST_Base_Schedule: "ON/OFF Command",
  };

  // Function to get display name for a parameter
  const getDisplayName = (attrKey) => {
    return allowedParameters[attrKey] || attrKey.replace(/_/g, " ");
  };

  // Function to check if parameter should be displayed
  const shouldShowParameter = (attrKey) => {
    return Object.keys(allowedParameters).includes(attrKey);
  };

  // Function to get ordered attributes
  const getOrderedAttributes = (attributes) => {
    if (!attributes) return [];

    // Filter and order attributes based on parameterOrder
    return parameterOrder
      .filter(
        (key) => attributes[key] !== undefined && shouldShowParameter(key)
      )
      .map((key) => [key, attributes[key]]);
  };

  const selectedType = "SS_EXHAUST_FAN";
  const devices = equipmentData[selectedType]
    ? Object.entries(equipmentData[selectedType]).sort((a, b) =>
        a[1].name.localeCompare(b[1].name)
      )
    : [];

  const handleFloorChange = (name, id) => {
    console.log("Floor change:", id, name);
    setFId(id);
    setFdata(name);
    setSelectedDevice(id);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {/* Floor Dropdown */}
        <Grid container item xs={12} spacing={2}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            style={{ marginLeft: "1vw" }}
          >
            <FormControl
              variant="filled"
              size="small"
              style={{
                width: "max-content",
                minWidth: "100%",
                backgroundColor: "#eeeef5",
              }}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Floor"
                className={classes.select}
                value={fdata}
                style={{
                  borderRadius: "0.8vw",
                  height: "6vh",
                  fontWeight: "bold",
                }}
                disableUnderline
              >
                <MenuItem
                  key="all-devices"
                  value="all"
                  onClick={() => handleFloorChange("all", "all")}
                >
                  All Floors
                </MenuItem>
                {floor.map((_item) => (
                  <MenuItem
                    key={_item.name}
                    value={_item.name}
                    onClick={() => handleFloorChange(_item.name, _item.id)}
                  >
                    {_item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Device Cards */}
        <Grid container item xs={12} spacing={2} style={{ marginTop: "2vh" }}>
          {console.log("fdata", fid)}
          {devices
            .filter(([deviceId, deviceInfo]) =>
              fid === "all" ? true : deviceInfo?.Equipment_Group === fid
            )
            .map(([deviceId, deviceInfo], index) => {
              // Get ordered attributes
              const orderedAttributes = getOrderedAttributes(
                deviceInfo?.Eqp_Attributes
              );

              return (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={deviceId}>
                  <Card className={classes.paper} style={{ height: "44vh" }}>
                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: "left", marginLeft: "2vh" }}
                      >
                        <div
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "2.5vh",
                            marginLeft: "2vh",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.2",
                            textAlign: "left",
                          }}
                        >
                          {/* {typeNameMap[selectedType]}-{" "} */}
                          {/* {floor.find(
                            (f) => f.id === deviceInfo.Equipment_Group
                          )?.name || " "}{" "} */}
                          {deviceInfo.name}
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      {/* Image */}
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={typeImageMap[selectedType]}
                          alt={typeNameMap[selectedType]}
                          style={{
                            width: "10vw",
                            height: "25vh",
                            objectFit: "contain",
                            marginTop: "3.5vh",
                            marginLeft: "5vh",
                          }}
                        />
                      </Grid>

                      {/* Attributes */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        style={{
                          overflowY:
                            orderedAttributes.length > 4 ? "auto" : "unset",
                          maxHeight:
                            orderedAttributes.length > 4 ? "30vh" : "unset",
                          paddingRight: "0.5vw",
                        }}
                      >
                        <Grid container spacing={1}>
                          {orderedAttributes.map(([attrKey, attrValue]) => (
                            <Grid item xs={6} key={attrKey}>
                              <Card className={classes.paper1}>
                                <div className={classes.cardHeading}>
                                  {getDisplayName(attrKey)}
                                </div>
                                <div
                                  style={{
                                    fontSize: "2.5vh",
                                    color: "#0123B4",
                                    fontWeight: "bold",
                                    whiteSpace: "normal",
                                    marginBottom: "2vh",
                                    marginTop: "1.2vh",
                                    lineHeight: "1.3",
                                    textAlign: "center",
                                  }}
                                >
                                  {formatValue(attrKey, attrValue.presentValue)}
                                </div>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </div>
  );
}
